import WpEditLink from './wp-edit-link';

export default WpEditLink;
